import {Injectable} from '@angular/core';
import {Subject} from "rxjs";

/**
 * setTimeout fix ExpressionChangedAfterItHasBeenCheckedError
 */
@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private _loading = new Subject<boolean>();

  public loading = this._loading.asObservable();

  constructor() {
  }

  show() {
    setTimeout(() =>this._loading.next(true));
  }

  hide() {
    setTimeout(() =>this._loading.next(false));
  }
}
